// components/landingPage/ImpactDashboard.jsx
import React from 'react';

const ImpactDashboard = () => {
  return (
    <section className="py-20 bg-gray-50 px-4">
      <div className="max-w-6xl mx-auto">
        <h2 className="text-4xl font-bold text-center text-gray-900 mb-4">
          Your Climate Impact So Far
        </h2>
        <p className="text-xl text-center text-gray-600 mb-12 max-w-2xl mx-auto">
          Track your progress in reducing waste, generating revenue, and making a positive environmental impact
        </p>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
          {/* Revenue Card */}
          <div className="bg-white rounded-2xl p-8 shadow-lg border-l-4 border-emerald-500">
            <h3 className="text-2xl font-bold text-gray-900 mb-6">Revenue Generated</h3>
            <div className="space-y-4">
              <div>
                <div className="text-3xl font-bold text-emerald-600">Kshs. 2,768,100</div>
                <div className="text-gray-600 text-sm mt-1">Total Revenue</div>
              </div>
              <div className="grid grid-cols-2 gap-4">
                <div>
                  <div className="text-lg font-semibold text-gray-900">Kshs. 0</div>
                  <div className="text-gray-600 text-sm">Remaining Potential</div>
                </div>
                <div>
                  <div className="text-lg font-semibold text-gray-900">Kshs. 2,768,100</div>
                  <div className="text-gray-600 text-sm">Delivered Orders</div>
                </div>
              </div>
            </div>
          </div>

          {/* Waste Prevention Card */}
          <div className="bg-white rounded-2xl p-8 shadow-lg border-l-4 border-blue-500">
            <h3 className="text-2xl font-bold text-gray-900 mb-6">Waste Prevention</h3>
            <div className="space-y-4">
              <div>
                <div className="text-3xl font-bold text-blue-600">60 KG</div>
                <div className="text-gray-600 text-sm mt-1">Waste Prevented</div>
              </div>
              <div className="grid grid-cols-2 gap-4">
                <div>
                  <div className="text-lg font-semibold text-gray-900">200 KG</div>
                  <div className="text-gray-600 text-sm">Remaining Potential</div>
                </div>
                <div>
                  <div className="text-lg font-semibold text-gray-900">4</div>
                  <div className="text-gray-600 text-sm">Active Listings</div>
                </div>
              </div>
            </div>
          </div>

          {/* Emissions Reduction Card */}
          <div className="bg-white rounded-2xl p-8 shadow-lg border-l-4 border-orange-500">
            <h3 className="text-2xl font-bold text-gray-900 mb-6">Emissions Reduction</h3>
            <div className="space-y-4">
              <div>
                <div className="text-3xl font-bold text-orange-600">150 kg CO₂e</div>
                <div className="text-gray-600 text-sm mt-1">Emissions Reduced</div>
              </div>
              <div className="grid grid-cols-2 gap-4">
                <div>
                  <div className="text-lg font-semibold text-gray-900">500 kg CO₂e</div>
                  <div className="text-gray-600 text-sm">Remaining Potential</div>
                </div>
                <div>
                  <div className="text-lg font-semibold text-gray-900">3</div>
                  <div className="text-gray-600 text-sm">Listings with Offers</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ImpactDashboard;